export default __webpack_public_path__ + "static/media/fundcard-bg.2c592019.svg";